export default {
  methods: {
    trackEvent(fb_event, category, action, label, type, value = "0"){
      // console.log("Tracking: ", fb_event, category);
      // console.log('MA: ', this.$ma)
      this.$ma.trackEvent({ fb_event, category, action, label, type, value });
      // event: null, // Event type [default = 'interaction'] (Optional)
      //   category: "Calculator",
      //   action: "click",
      //   label: "Home page SIP calculator",
      //   value: 5000,
      const event = fb_event;
      this.$gtm.trackEvent({ event, category, action, label, value })
    }
  }
};
